import { render, staticRenderFns } from "./FireAlarmReportView.vue?vue&type=template&id=4f0a8833&"
import script from "./FireAlarmReportView.vue?vue&type=script&lang=js&"
export * from "./FireAlarmReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports